import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import About from "@/pages/About";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Shipments from "@/pages/Shipments";
import BookLoad from "@/pages/BookLoad";
import Documents from "@/pages/Documents";
import Tracking from "@/pages/Tracking";
import HSLookup from "@/pages/HSLookup";
import Trailers from "@/pages/Trailers";
import Integrations from "@/pages/Integrations";
import Connections from "@/pages/Connections";
import ProviderOutreach from "@/pages/ProviderOutreach";
import InvestorBoardroom from "@/pages/InvestorBoardroom";
import MarketingPack from "@/pages/MarketingPack";
import Landing from "@/pages/Landing";
import Services from "@/pages/Services";
import Lanes from "@/pages/Lanes";
import Contact from "@/pages/Contact";
import PublicInvestors from "@/pages/PublicInvestors";
import TmsInvestors from "@/pages/TmsInvestors";
import TmsInviteLinks from "@/pages/TmsInviteLinks";
import MarginShield from "@/pages/MarginShield";
import BrokerageOpsKpis from "@/pages/BrokerageOpsKpis";
import OriseiOperations from "@/pages/OriseiOperations";
import International from "@/pages/International";
import ShipperIntake from "@/pages/ShipperIntake";
import ShipperRelations from "@/pages/ShipperRelations";
import ClaimsMaster from "@/pages/ClaimsMaster";
import QbrStudio from "@/pages/QbrStudio";
import LighthouseOutreach from "@/pages/LighthouseOutreach";
import PublicTour from "@/pages/PublicTour";
import PublicIntake from "@/pages/PublicIntake";
import OnboardingChecklist from "@/pages/OnboardingChecklist";
import Boc3Compliance from "@/pages/Boc3Compliance";
import CustomerPortal from "@/pages/CustomerPortal";
import CompetitiveTms from "@/pages/CompetitiveTms";
import EnterpriseTms from "@/pages/EnterpriseTms";
import ResearchAnalytics from "@/pages/ResearchAnalytics";
import PublicRfpBoard from "@/pages/PublicRfpBoard";
import DriverPwa from "@/pages/DriverPwa";
import GtmAssets from "@/pages/GtmAssets";
import Reports from "@/pages/Reports";
import Chat from "@/pages/Chat";
import QuickLinks from "@/pages/QuickLinks";
import FreightPay from "@/pages/FreightPay";
import CarrierOnboarding from "@/pages/CarrierOnboarding";
import DriverConsole from "@/pages/DriverConsole";
import DriverMobile from "@/pages/DriverMobile";
import AdminUsers from "@/pages/AdminUsers";
import SapSync from "@/pages/SapSync";
import AIAssistant from "@/pages/AIAssistant";
import Webex from "@/pages/Webex";
import PromoVideo from "@/pages/PromoVideo";
import Workbook from "@/pages/Workbook";
import CarrierRates from "@/pages/CarrierRates";
import Music from "@/pages/Music";
import Manual from "@/pages/Manual";
import Vault from "@/pages/Vault";
import Claims from "@/pages/Claims";
import CarrierInvites from "@/pages/CarrierInvites";
import AcceptInvite from "@/pages/AcceptInvite";
import TradeCompliance from "@/pages/TradeCompliance";
import SupplierSourcing from "@/pages/SupplierSourcing";
import Arcade from "@/pages/Arcade";
import Machines from "@/pages/Machines";
import Equipment from "@/pages/Equipment";
import RoutingGuide from "@/pages/RoutingGuide";
import MicrosoftCopilot from "@/pages/MicrosoftCopilot";
import PowerBI from "@/pages/PowerBI";
import SharePoint from "@/pages/SharePoint";
import AdminSettings from "@/pages/AdminSettings";
import RoadReference from "@/pages/RoadReference";
import NicheCargo from "@/pages/NicheCargo";
import CarrierNetwork from "@/pages/CarrierNetwork";
import NicheMarkets from "@/pages/NicheMarkets";
import NetWorth from "@/pages/NetWorth";
import DynamicPricing from "@/pages/DynamicPricing";
import AdminDashboard from "@/pages/AdminDashboard";
import Brokerage from "@/pages/Brokerage";
import OperationSandbox from "@/pages/OperationSandbox";
import LiveOps from "@/pages/LiveOps";
import RevenueEngine from "@/pages/RevenueEngine";
import GetQuote from "@/pages/GetQuote";
import CarrierLoadboard from "@/pages/CarrierLoadboard";
import SpecialtyCarriers from "@/pages/SpecialtyCarriers";
import DriverRegistry from "@/pages/DriverRegistry";
import WorkflowChecklist from "@/pages/WorkflowChecklist";
import BrokerSettings from "@/pages/BrokerSettings";
import Factoring from "@/pages/Factoring";
import CashFlow from "@/pages/CashFlow";
import ShipmentTriage from "@/pages/ShipmentTriage";
import BrandKit from "@/pages/BrandKit";
import DocumentArchive from "@/pages/DocumentArchive";
import LaunchPlan from "@/pages/LaunchPlan";
import Invoices from "@/pages/Invoices";
import FleetRouting from "@/pages/FleetRouting";
import CarrierIntegrations from "@/pages/CarrierIntegrations";
import DispatchAutopilot from "@/pages/DispatchAutopilot";
import AgentSentinel from "@/pages/AgentSentinel";
import LaunchBlast from "@/pages/LaunchBlast";
import RouteOptimizer from "@/pages/RouteOptimizer";
import GrowthCopilot from "@/pages/GrowthCopilot";
import HotShotLanding from "@/pages/HotShotLanding";
import HotShotSales from "@/pages/HotShotSales";
import TenantCommand from "@/pages/TenantCommand";
import PlatformReadiness from "@/pages/PlatformReadiness";
import TruckCleaning from "@/pages/TruckCleaning";
import WashLanding from "@/pages/WashLanding";
import CrewPortal from "@/pages/CrewPortal";
import BrokerAutopilot from "@/pages/BrokerAutopilot";
import ResilienceCenter from "@/pages/ResilienceCenter";
import TcOnboardPublic from "@/pages/TcOnboardPublic";
import TcInvoicePublic from "@/pages/TcInvoicePublic";
import TcReschedulePublic from "@/pages/TcReschedulePublic";
import TcProofPublic from "@/pages/TcProofPublic";
import TcScentCardPublic from "@/pages/TcScentCardPublic";
import TcSignPublic from "@/pages/TcSignPublic";
import TenantLogin from "@/pages/tenant/TenantLogin";
import TenantPortal from "@/pages/tenant/TenantPortal";
import AppErrorBoundary from "@/components/AppErrorBoundary";
import WellnessNudges from "@/components/WellnessNudges";
import { ThemeProvider } from "@/lib/theme";
import { BrandingProvider } from "@/lib/branding";
import { MusicProvider } from "@/lib/music";
import MiniPlayer from "@/components/MiniPlayer";
import DeployHealthBanner from "@/components/DeployHealthBanner";

function RootRedirect() {
  // Public root: just show the Landing page. Authenticated operators have
  // /dashboard in the sidebar / can sign in via the nav. This way the public
  // root of the domain is the marketing site, exactly as a customer expects.
  return <Landing />;
}

function AppRouter() {
  const location = useLocation();
  // Synchronous check (before useEffects) — handle Emergent OAuth fragment
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<RootRedirect />} />
      <Route path="/login" element={<Login />} />
      <Route path="/home" element={<Landing />} />
      <Route path="/services" element={<Services />} />
      <Route path="/lanes" element={<Lanes />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/investors" element={<PublicInvestors />} />
      <Route path="/press" element={<PublicInvestors />} />
      <Route path="/exec-summary" element={<PublicInvestors />} />
      <Route path="/tms-investors" element={<TmsInvestors />} />
      <Route path="/tms-pitch" element={<TmsInvestors />} />
      <Route path="/demo" element={<TmsInvestors />} />
      <Route path="/about" element={<About />} />
      <Route path="/marketing" element={<About />} />
      <Route path="/landing" element={<About />} />
      <Route path="/accept-invite" element={<AcceptInvite />} />
      <Route path="/customer-portal" element={<CustomerPortal />} />
      <Route path="/rfp-board" element={<PublicRfpBoard />} />
      <Route path="/driver" element={<DriverPwa />} />
      {/* Driver mobile is auth-free */}
      <Route path="/driver" element={<DriverMobile />} />
      <Route path="/driver/:shipmentId" element={<DriverMobile />} />
      <Route path="/i/:token" element={<PublicIntake />} />
      <Route path="/tc/onboard/:token" element={<TcOnboardPublic />} />
      <Route path="/wash" element={<WashLanding />} />
      <Route path="/crew" element={<CrewPortal />} />
      <Route path="/tc/invoice/:invoiceId" element={<TcInvoicePublic />} />
      <Route path="/tc/reschedule/:token" element={<TcReschedulePublic />} />
      <Route path="/tc/proof/:token" element={<TcProofPublic />} />
      <Route path="/tc/scent/:token" element={<TcScentCardPublic />} />
      <Route path="/tc/sign/:token" element={<TcSignPublic />} />
      <Route path="/tour" element={<PublicTour />} />
      <Route path="/get-quote" element={<GetQuote />} />
      <Route path="/carriers/loadboard" element={<CarrierLoadboard />} />
      <Route path="/t/:slug/login" element={<TenantLogin />} />
      <Route path="/t/:slug/app" element={<TenantPortal />} />
      <Route path="/t/:slug/app/:tab" element={<TenantPortal />} />

      <Route path="/hotshot" element={<ProtectedRoute><HotShotLanding /></ProtectedRoute>} />
      <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/shipments" element={<Shipments />} />
        <Route path="/book-load" element={<BookLoad />} />
        <Route path="/brokerage" element={<Brokerage />} />
        <Route path="/sandbox" element={<OperationSandbox />} />
        <Route path="/live-ops" element={<LiveOps />} />
        <Route path="/revenue" element={<RevenueEngine />} />
        <Route path="/documents" element={<Documents />} />
        <Route path="/tracking" element={<Tracking />} />
        <Route path="/live-tracking" element={<Tracking />} />
        <Route path="/fleet-routing" element={<FleetRouting />} />
        <Route path="/carrier-integrations" element={<CarrierIntegrations />} />
        <Route path="/dispatch-autopilot" element={<DispatchAutopilot />} />
        <Route path="/hs-lookup" element={<HSLookup />} />
        <Route path="/trailers" element={<Trailers />} />
        <Route path="/integrations" element={<Integrations />} />
        <Route path="/connections" element={<Connections />} />
        <Route path="/provider-outreach" element={<ProviderOutreach />} />
        <Route path="/investor-boardroom" element={<InvestorBoardroom />} />
        <Route path="/investor-invite-links" element={<TmsInviteLinks />} />
        <Route path="/margin-shield" element={<MarginShield />} />
        <Route path="/workflow" element={<WorkflowChecklist />} />
        <Route path="/broker-settings" element={<BrokerSettings />} />
        <Route path="/factoring" element={<Factoring />} />
        <Route path="/cash-flow" element={<CashFlow />} />
        <Route path="/triage" element={<ShipmentTriage />} />
        <Route path="/brand-kit" element={<BrandKit />} />
        <Route path="/sentinel" element={<AgentSentinel />} />
        <Route path="/launch-blast" element={<LaunchBlast />} />
        <Route path="/route-optimizer" element={<RouteOptimizer />} />
        <Route path="/road-reference" element={<RoadReference />} />
        <Route path="/niche-cargo" element={<NicheCargo />} />
        <Route path="/carrier-network" element={<CarrierNetwork />} />
        <Route path="/niche-markets" element={<NicheMarkets />} />
        <Route path="/net-worth" element={<NetWorth />} />
        <Route path="/dynamic-pricing" element={<DynamicPricing />} />
        <Route path="/growth-copilot" element={<GrowthCopilot />} />
        <Route path="/hotshot-sales" element={<HotShotSales />} />
        <Route path="/tenant-command" element={<TenantCommand />} />
        <Route path="/platform-readiness" element={<PlatformReadiness />} />
        <Route path="/truck-cleaning" element={<TruckCleaning />} />
        <Route path="/broker-autopilot" element={<BrokerAutopilot />} />
        <Route path="/resilience" element={<ResilienceCenter />} />
        <Route path="/document-archive" element={<DocumentArchive />} />
        <Route path="/launch-plan" element={<LaunchPlan />} />
        <Route path="/launch-runway" element={<LaunchPlan />} />
        <Route path="/invoices" element={<Invoices />} />
        <Route path="/brokerage-ops-kpis" element={<BrokerageOpsKpis />} />
        <Route path="/orisei-operations" element={<OriseiOperations />} />
        <Route path="/international" element={<International />} />
        <Route path="/shipper-intake" element={<ShipperIntake />} />
        <Route path="/shipper-relations" element={<ShipperRelations />} />
        <Route path="/claims-master" element={<ClaimsMaster />} />
        <Route path="/qbr-studio" element={<QbrStudio />} />
        <Route path="/lighthouse-outreach" element={<LighthouseOutreach />} />
        <Route path="/onboarding-checklist" element={<OnboardingChecklist />} />
        <Route path="/boc3-compliance" element={<Boc3Compliance />} />
        <Route path="/competitive-tms" element={<CompetitiveTms />} />
        <Route path="/enterprise-tms" element={<EnterpriseTms />} />
        <Route path="/research-analytics" element={<ResearchAnalytics />} />
        <Route path="/gtm-assets" element={<GtmAssets />} />
        <Route path="/marketing-pack" element={<MarketingPack />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/links" element={<QuickLinks />} />
        <Route path="/freight-pay" element={<FreightPay />} />
        <Route path="/carrier-onboarding" element={<CarrierOnboarding />} />
        <Route path="/driver-console" element={<DriverConsole />} />
        <Route path="/sap-sync" element={<SapSync />} />
        <Route path="/ai-assistant" element={<AIAssistant />} />
        <Route path="/hudlink" element={<AIAssistant />} />
        <Route path="/copilot" element={<MicrosoftCopilot />} />
        <Route path="/microsoft-copilot" element={<MicrosoftCopilot />} />
        <Route path="/routing-guide" element={<RoutingGuide />} />
        <Route path="/legacy-hudlink" element={<AIAssistant />} />
        <Route path="/powerbi" element={<PowerBI />} />
        <Route path="/sharepoint" element={<SharePoint />} />
        <Route path="/admin/settings" element={<AdminSettings />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/specialty-carriers" element={<SpecialtyCarriers />} />
        <Route path="/driver-registry" element={<DriverRegistry />} />
        <Route path="/webex" element={<Webex />} />
        <Route path="/promo" element={<PromoVideo />} />
        <Route path="/workbook" element={<Workbook />} />
        <Route path="/carrier-rates" element={<CarrierRates />} />
        <Route path="/music" element={<Music />} />
        <Route path="/manual" element={<Manual />} />
        <Route path="/vault" element={<Vault />} />
        <Route path="/claims" element={<Claims />} />
        <Route path="/carrier-invites" element={<CarrierInvites />} />
        <Route path="/trade-compliance" element={<TradeCompliance />} />
        <Route path="/suppliers" element={<SupplierSourcing />} />
        <Route path="/machines" element={<Machines />} />
        <Route path="/equipment" element={<Equipment />} />
        <Route path="/arcade" element={<Arcade />} />
        <Route path="/admin/users" element={<AdminUsers />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <AppErrorBoundary>
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <BrandingProvider>
              <MusicProvider>
                <DeployHealthBanner />
                <AppRouter />
                <MiniPlayer />
                <WellnessNudges />
                <Toaster
                  theme="dark"
                  position="bottom-right"
                  toastOptions={{
                    style: { background: "#131821", border: "1px solid rgba(0,229,255,0.3)", color: "#F8FAFC" }
                  }}
                />
              </MusicProvider>
            </BrandingProvider>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </AppErrorBoundary>
  );
}
